import React from "react";

const StepsSection = ({ sellerData }) => {
  const textData = sellerData?.benefits?.find(
    (item) => item.layout === "image_value"
  );

  const title = textData?.attributes?.title;
  const description = textData?.attributes?.description;
  const image = textData?.attributes?.image;

  return (
    <section className="step py-80">
      <div className="position-relative z-1">
        {/* <img
          src="assets/images/shape/curve-line-shape.png"
          alt=""
          className="position-absolute top-0 inset-inline-end-0 z-n1 me-60 d-lg-block d-none"
        /> */}
        <div className="container container-lg">
          <div className="row gy-4">
            <div className="col-lg-6">
              <div className="step-content">
                <div className="section-heading ms-auto text-end">
                  <h5>{title}</h5>
                  <span className="text-gray-600">{description}</span>
                </div>

                <div className="d-flex flex-column align-items-end gap-56">
                  {sellerData?.benefits?.length > 0 &&
                    sellerData?.benefits.map((value, key) =>
                      value?.layout === "text_value" ? (
                        <div
                          className="d-flex align-items-center gap-32"
                          key={value?.id}
                        >
                          <div className="text-end">
                            <h5 className="mb-8">{value?.attributes?.title}</h5>
                            <p className="text-gray-600">
                              {value?.attributes?.description}
                            </p>
                          </div>
                          <div className="w-90 h-90 flex-center bg-main-product-50 rounded-circle">
                            <h6
                              className="mb-0 w-60 h-60 product-card__cart text-white d-flex align-items-center justify-content-center rounded-circle border border-5 border-white fw-medium"
                              style={{ fontSize: "20px" }}
                            >
                              {key}
                            </h6>
                          </div>
                        </div>
                      ) : null
                    )}
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="text-center">
                <img src={image?.files?.large?.url} alt="" className="w-75 " />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StepsSection;
